var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gallery_card" }, [
    _c("div", { staticClass: "table table-responsive" }, [
      _c("table", { staticClass: "table" }, [
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v("\n          Name\n          "),
              _c("i", {
                staticClass: "fa fa-arrow-down",
                on: {
                  click: function($event) {
                    return _vm.setSortOrder("t-d")
                  }
                }
              }),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-arrow-up",
                on: {
                  click: function($event) {
                    return _vm.setSortOrder("t-a")
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v("\n          Author\n          "),
              _c("i", {
                staticClass: "fa fa-arrow-down",
                on: {
                  click: function($event) {
                    return _vm.setSortOrder("a-d")
                  }
                }
              }),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-arrow-up",
                on: {
                  click: function($event) {
                    return _vm.setSortOrder("a-d")
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v("\n          Last Updated Date\n          "),
              _c("i", {
                staticClass: "fa fa-arrow-down",
                on: {
                  click: function($event) {
                    return _vm.setSortOrder("d-d")
                  }
                }
              }),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-arrow-up",
                on: {
                  click: function($event) {
                    return _vm.setSortOrder("d-a")
                  }
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.newList, function(item, index) {
            return _c(
              "tr",
              {
                key: index,
                on: {
                  click: function($event) {
                    return _vm.viewStoryDetail(item)
                  }
                }
              },
              [
                _c("td", [_vm._v(_vm._s(item.title))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.author))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.date))])
              ]
            )
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c("hr")
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fbe792e0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbe792e0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story-list-view/listCard1.vue
// module id = null
// module chunks = 